require('./news.less');
require('../../plugins/jquery.loader/require.js');

jQuery(function() {
    $('.wrapper').on('click', '.pagination__btn-more', function(event) {
        event.preventDefault();

        var $this = $(this);
        var pageCurrent = $this.data('page');
        $this
            .parent()
            .parent()
            .remove();

        window.mxLoader && window.mxLoader.show();

        $.ajax({
            type: 'GET',
            url: '/ajax/component/maximaster:news.list/.default/',
            data: {
                page: pageCurrent
            },
            success: function(response) {
                window.mxLoader && window.mxLoader.hide(0);

                if (response.code === 200) {
                    let newSection = $(response.html);
                    $('.js-grid-news:last').append(newSection[0].innerHTML);
                    $('.js-grid-news:last').append(newSection[1].outerHTML);
                } else {
                    console.error(response.message);
                }
            },
            dataType: 'json'
        });

        return false;
    });
    $('.js-news-block').on('click',function(){
        let link = $(this).find('a').attr('href');
        window.location.href = link;
    })
});



// WEBPACK FOOTER //
// ./blocks/news/news.js